// extracted by mini-css-extract-plugin
export default {"title":"list-documents_style_title__6ZXrP","documentName":"list-documents_style_documentName__H+l+X"};